import { z } from 'zod'

import { CuratedListNotificationType } from '../constants/curatedList'
import { dbEntitySchema, listQueryZodFields } from './system'

export const curatedListFollowSchema = dbEntitySchema.extend({
  user: z.string(),
  curatedList: z.string(),
  notifications: z.object({
    push: z.boolean(),
  }),
})

export const curatedListFollowUpdateArgsSchema = z.object({
  notifications: z
    .object({
      push: z.boolean().optional(),
    })
    .optional(),
})

export const curatedListFollowListQuerySchema = z.object({
  ...listQueryZodFields,
  curatedListId: z.string().optional().nullable(),
})

export const curatedListNotificationArgsSchema = z.object({
  type: z.nativeEnum(CuratedListNotificationType),
  message: z.string().min(1),
  url: z.string().optional().nullable(),
})

export const curatedListNotificationResponseSchema = z.object({
  count: z.number(),
})
